/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import { MdEdit } from "react-icons/md";
import localOriginCharges from "../../../Services/localOriginCharges";
import { ChangeStatus } from "../../../Components";
// import { Storage } from "../../../Storage/Storage";
import Loader from "../../../Components/Loader";
import Select from "react-select";
import locationServices from "../../../Services/locationServices";

export const AirConsolidationOriginChargeList = () => {
  // const [airLocalOriginChargeList, setAirLocalOriginChargeList] = useState(Storage.get('getLocalOriginChargeAir') ? Storage.get('getLocalOriginChargeAir') : [])
  const [airLocalOriginChargeList, setAirLocalOriginChargeList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [countryList, setCountryList] = useState([]);
  const [countryValue, setCountryValue] = useState("");
  const history = useHistory();

  useEffect(() => {
    getAirLocalOriginChargeList();
    // eslint-disable-next-line
  }, [currentPage]);

  useEffect(() => {
    getCountryList();
    // eslint-disable-next-line
  }, []);

  const getCountryList = () => {
    let param = {
      limit: 250,
      page: 1,
    };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        // arry.push({ value: '', label: 'All country' })
        // eslint-disable-next-line
        res.data.map((list) => {
          arry.push({
            value: list.country_name,
            label: list.country_name,
            data: list,
          });
        });
        let activeCountry = arry.filter(
          (item) => item.data.country_currency === "AED"
        );
        if (activeCountry.length) {
          onSelectCountry(activeCountry[0]);
        }
        setLoader(false);
        setCountryList(arry);
      }
    });
  };

  const getAirLocalOriginChargeList = () => {
    let param = { ...pagination, page: currentPage };
    localOriginCharges.getLocalOriginConsolidationChargeAir(param).then((res) => {
      if (res.status) {
        // Storage.set('getLocalOriginChargeAir', res.data)
        setAirLocalOriginChargeList(res.data);
        setPagination(res.pagination);
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      country_id: isModalOpen.country._id,
        awb_fee: isModalOpen.awb_fee,
        handling_in: isModalOpen.handling_in,
        handling_out: isModalOpen?.handling_out || 0,
        airline_handling: isModalOpen.airline_handling,
        customs_docs: isModalOpen.customs_docs,
        transport_s2d_to_apt: isModalOpen.transport_s2d_to_apt,
        min_handling_in: isModalOpen.min_handling_in,
        min_handling_out: isModalOpen?.min_handling_out || 0,
        min_airline_handling: isModalOpen.min_airline_handling,
        min_customs_docs: isModalOpen?.min_customs_docs || 0,
        min_transport_s2d_to_apt: isModalOpen.min_transport_s2d_to_apt,
        id: isModalOpen._id,
        local_origin_charge_status:
          isModalOpen.local_origin_charge_status === "ACTIVE"
          ? "INACTIVE"
          : "ACTIVE",
    };

    localOriginCharges
      .updateLocalOriginConsolidationChargeAir(postData)
      .then((res) => {
        if (res.status) {
          setIsModalOpen(false);
          getAirLocalOriginChargeList();
        }
      });
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const onSelectCountry = (e) => {
    setCountryValue(e, "United Arab Emirates");
    // getAirFreightRateList(e.value)
  };
  return (
    <div className="row justify-content-center">
      <div className=" col-lg-6">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div>
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      width: "200px",
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  // placeholder="United Arab Emirates"
                  value={countryValue}
                  onChange={(e) => onSelectCountry(e)}
                  options={countryList}
                  isDisabled
                />
              </div>
              {/* <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div> */}
              <button
                className="btn btn-primary w-sm waves-effect waves-light"
                onClick={() => history.push("/add-air-consolidation-origin-charge")}
              >
                Add Air Consolidation Origin Charge
              </button>
            </div>

            <div className="row"></div>

            <div className="customTbl_lt">
              <div className="thead_left">
                <div>S no.</div>
                <div>Country</div>
                <div>Awb Fee(Aed)</div>
                <div>Customs Docs(Aed)</div>
                <div>Transport ( S2D to Apt) in Aed</div>
                <div>Minimum Transport ( S2D to Apt) in Aed</div>
                <div>Airline Handling /Kg</div>
                <div>Minimum Airline Handling (Aed)</div>
                <div>Handling In/Out per cbm</div>
                <div>Minimum Handling In/Out (Aed)</div>
                <div>Status</div>
                <div>Action</div>
              </div>
              <div className="tbody_left">
                {airLocalOriginChargeList.length > 0 &&
                  airLocalOriginChargeList.map((item, key) => (
                    <div className="tr" key={key}>
                      <div className="text-body fw-bold">
                        {(pagination.page - 1) * pagination.limit + (key + 1)}
                      </div>
                      <div>{item.country.country_name}</div>
                      <div>{item.awb_fee}</div>
                      <div>{item.customs_docs}</div>
                      {/* <div>{item.min_customs_docs}</div> */}
                      <div>{item.transport_s2d_to_apt}</div>
                      <div>{item.min_transport_s2d_to_apt}</div>
                      <div>{item.airline_handling}</div>
                      <div>{item.min_airline_handling}</div>
                      <div>{item.handling_in}</div>
                      <div>{item.min_handling_in}</div>
                      <div>
                        {" "}
                        <span
                          className={
                            "badge rounded-pill font-size-12 pointer" +
                            (item.local_origin_charge_status === "ACTIVE"
                              ? " bg-success"
                              : " bg-soft-danger")
                          }
                          onClick={() => setIsModalOpen(item)}
                        >
                          {item.local_origin_charge_status}
                        </span>
                      </div>
                      <div>
                        {" "}
                        {/* Button trigger modal */}
                        <MdEdit
                          className="pointer"
                          onClick={() =>
                            history.push(
                              "/edit-air-consolidation-origin-charge?id=" + item._id,
                              item
                            )
                          }
                          color="#0323fe"
                          size="25px"
                        />
                        {/* <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('/air-origin-courier-charge-details?id=' + item._id, item)}
                                                color="#0323fe"
                                                size="25px"
                                            /> */}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {airLocalOriginChargeList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={<img src="assets/images/prev.svg" height={15} alt='prev'/>}
                forcePage={currentPage - 1}
                nextLabel={<img src="assets/images/next.svg" height={15} alt='next' />}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.local_origin_charge_status === "ACTIVE"
                ? "Inactive"
                : "Active"
            } status?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
